(function () {
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?/;

  function ShippingBar(el) {
    this.el = el;
    this.threshold = parseInt(el.dataset.threshold, 10) || 0;
    this.textBefore = el.dataset.textBefore || '';
    this.textAfter = el.dataset.textAfter || '';
    this.messageEl = el.querySelector('[data-shipping-bar-message]');
    this.fillEl = el.querySelector('[data-shipping-bar-fill]');
    this.boundRefresh = this.refresh.bind(this);
    this.init();
  }

  ShippingBar.prototype.init = function () {
    this.refresh();
    document.addEventListener('cart:updated', this.boundRefresh);
    document.addEventListener('cart:refresh', this.boundRefresh);
    document.addEventListener('cart:build', this.boundRefresh);
  };

  ShippingBar.prototype.formatMoney = function (cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  };

  ShippingBar.prototype.update = function (cartTotal) {
    if (!this.threshold) return;
    var remaining = this.threshold - cartTotal;
    var percent = Math.min(100, Math.max(0, (cartTotal / this.threshold) * 100));
    this.fillEl.style.width = percent + '%';

    if (remaining <= 0) {
      this.el.setAttribute('data-complete', 'true');
      this.messageEl.textContent = this.textAfter;
    } else {
      this.el.setAttribute('data-complete', 'false');
      this.messageEl.textContent = this.textBefore.replace('{amount}', this.formatMoney(remaining));
    }
  };

  ShippingBar.prototype.refresh = function () {
    var self = this;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { self.update(cart.total_price); })
      .catch(function (e) { console.error('Shipping bar: cart fetch failed', e); });
  };

  function initAll(root) {
    (root || document).querySelectorAll('[data-shipping-bar]:not([data-shipping-bar-init])').forEach(function (el) {
      el.setAttribute('data-shipping-bar-init', 'true');
      new ShippingBar(el);
    });
  }

  function patchFetch() {
    if (window.__shippingBarFetchPatched) return;
    window.__shippingBarFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var isCartMutation = CART_MUTATION_RE.test(url);
      var result = originalFetch.apply(this, arguments);
      if (isCartMutation) {
        result.then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }).catch(function () {});
      }
      return result;
    };
  }

  function patchXHR() {
    if (window.__shippingBarXHRPatched) return;
    window.__shippingBarXHRPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__shippingBarUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      this.addEventListener('load', function () {
        if (self.__shippingBarUrl && CART_MUTATION_RE.test(self.__shippingBarUrl)) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      });
      return origSend.apply(this, arguments);
    };
  }

  patchFetch();
  patchXHR();

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  // Safety net: catch drawer re-renders that swap the whole node
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-shipping-bar]')) {
          initAll(node.parentNode);
        } else if (node.querySelectorAll) {
          initAll(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();